import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 320px;
   font-size: 15px;
   display: block;
   text-align: center;
`;